//引入axios 使用多接口并发请求
import axios from 'axios';
//引入群组相关接口
import { queryProjectInfo,queryProjectColumn,queryTask,queryProjectUsersSellers,getOrderInfo,checkOnly,pddPlugInDetection,pddPlugInSetPddRedis,getTaskRelationRule,getTaskRepeatNumAndNames, checkShareEditCount, submitCheckRules} from './../../api/project';
//引入班牛群组相关数据整理方法
import {formattingProjectInfo,formattingColumns,formattingTaskData} from './../../util/formattingProjectData'
//数据格式化相关方法
const state = {
  projectInfo:{},//群组信息
  columns:[],//群组组建列
  task:[],//群组组建列
};
const mutations = {
  SET_PROJECT:(state, projectInfo) => {
    state.projectInfo = projectInfo
  },
  SET_COLUMN:(state, columns) => {
    state.columns = columns
  },
  SET_TASK:(state, task) => {
    state.task = task
  },
}

const actions = {
  //获取群组详情
  getProjectInfo({ commit }, project) {
    return new Promise((resolve, reject) => {
      //多接口并发请求
      axios.all([
        queryProjectInfo({ id: project.projectId }),
        queryProjectColumn({ id: project.projectId }),
        queryProjectUsersSellers({ id: project.projectId }),
        queryTask({id: project.projectId,task:project.taskId})
      ]).then(axios.spread(function (project, column,usersSellers,task) {
        let projectInfo = formattingProjectInfo(project.data,usersSellers.data.userList,usersSellers.data.shopList);
        let columns = formattingColumns(column.data.queryColumns,projectInfo);
        let taskInfo = formattingTaskData(task.data.taskList[0],columns);
        commit('SET_PROJECT',projectInfo);
        commit('SET_COLUMN',columns);
        commit('SET_TASK',taskInfo);
        resolve({projectInfo:projectInfo,columns:columns,taskInfo:taskInfo})
      })).catch(error =>{
        console.log(error)
        reject(error)
      })
    })
  },
  landUser({commit},account){
    commit('SET_ISLAND',true)
  },
  changeName({ commit }, userInfo) {
    const name = 'ceshishishi';
    console.log(123666)
    commit('SET_NAME',name)
    console.log(userInfo)
  },
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { data } = response

        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const { roles, name, avatar, introduction } = data

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!')
        }

        commit('SET_ROLES', roles)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_INTRODUCTION', introduction)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        resetRouter()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },
  changeRoles({ commit, dispatch }, role) {
    return new Promise(async resolve => {
      const token = role + '-token'

      commit('SET_TOKEN', token)
      setToken(token)

      const { roles } = await dispatch('getInfo')

      resetRouter()

      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })

      // dynamically add accessible routes
      router.addRoutes(accessRoutes)

      // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
    })
  },
  //创建任务-拉取订单相关数据
  getOrderInfo({commit},data){
    return new Promise((resolve,reject) =>{
      getOrderInfo(data).then(res=>{
        resolve(res)
      }).catch(err=>{
        reject(err)
      })
    })
  },
  //校验组件数据唯一
  checkOnly({commit}, data) {
    return new Promise((resolve, reject) => {
      checkOnly(data).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  //拼多多插件检测
  pddPlugInDetection({commit}, data) {
    return new Promise((resolve, reject) => {
      pddPlugInDetection(data).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  // 拼多多安全改造
  pddPlugInSetPddRedis({commit}, data) {
    return new Promise((resolve, reject) => {
      pddPlugInSetPddRedis(data).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  //查询关联工单规则信息
  getTaskRelationRule({commit},data){
    return new Promise((resolve,reject) =>{
      getTaskRelationRule(data).then(res=>{
        resolve(res)
      }).catch(err=>{
        reject(err)
      })
    })
  },
  //关联查询工单-全局搜索工单数量/工作表名称
  getTaskRepeatNumAndNames({commit},data){
    return new Promise((resolve,reject) =>{
      getTaskRepeatNumAndNames(data).then(res=>{
        resolve(res)
      }).catch(err=>{
        reject(err)
      })
    })
  },
  //获取编辑分享次数限制
  checkShareEditCount({commit},data){
    return new Promise((resolve,reject) =>{
      checkShareEditCount(data).then(res=>{
        resolve(res)
      }).catch(err=>{
        reject(err)
      })
    })
  },

  // 输入完成时校验
  submitCheckRules({commit},data){
    return new Promise((resolve,reject) =>{
      submitCheckRules(data).then(res=>{
        resolve(res)
      }).catch(err=>{
        reject(err)
      })
    })
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/project.js